import React from "react";

const ViewPhq9 = ({ data, ismodalopen, setHtmlModal }) => {
  if (!ismodalopen || !data || !data.json_data) return null;

  const json = data.json_data;

  const closeModal = () => setHtmlModal(false);

  const questions = [
    { q: "Little interest or pleasure in doing things", key: "qanswer_4_1" },
    { q: "Feeling down, depressed or hopeless", key: "qanswer_4_2" },
    { q: "Trouble falling or staying asleep, or sleeping too much", key: "qanswer_4_3" },
    { q: "Feeling tired or having little energy", key: "qanswer_4_4" },
    { q: "Poor appetite or overeating", key: "qanswer_4_5" },
    {
      q: "Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
      key: "qanswer_4_6",
    },
    {
      q: "Trouble concentrating on things, such as reading the newspaper or watching television",
      key: "qanswer_4_7",
    },
    {
      q: "Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual",
      key: "qanswer_4_8",
    },
    { q: "Thoughts that you would be better off dead or of hurting yourself in some way", key: "qanswer_4_9" },
  ];

  const optionLabels = ["Not at all", "Several days", "More than half the days", "Nearly every day"];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto text-start">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{json.form_name}</h2>
          <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
            &times;
          </button>
        </div>

        {/* Intro */}
        <div className="mb-4">
          <p className="font-bold text-lg mb-2">Are you feeling depressed?</p>
          <p className="mb-2 text-gray-700">
            Many people think of depression as simply being sad. But it's more than sadness. It’s a combination of multiple symptoms.
            Fill out the questionnaire below, and take it with you to your next appointment. This is not a complete diagnostic tool,
            so be sure to talk with your healthcare provider about all your depressive symptoms. It’s important to discuss potential
            treatment options that may help you.
          </p>
        </div>

        <p className="mb-4 text-gray-700 font-semibold">
          Over the last 2 weeks, how often have you been bothered by any of the following problems?
        </p>

        {/* Table Layout */}
        <table className="w-full border-collapse mb-6">
          <thead>
            <tr>
              <th className="text-left p-2"></th>
              {optionLabels.map((label, idx) => (
                <th key={idx} className="text-center p-2 font-semibold">{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {questions.map((q, idx) => (
              <tr key={idx}>
                <td className="p-2 font-bold">{q.q}</td>
                {[0, 1, 2, 3].map((val) => (
                  <td key={val} className="text-center p-2">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-sans border ${
                        Number(json[q.key]) === val
                          ? "bg-blue-600 text-white border-blue-600"
                          : "bg-white border-gray-300 text-black"
                      }`}
                    >
                      {val}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals */}
        <div className="mt-4">
          <h3 className="font-bold text-lg mb-2">Score Summary</h3>
          <p>Not at all: {json.several_count}</p>
          <p>Several days: {json.halfday_count}</p>
          <p>Nearly every day: {json.everyday_count}</p>
          <p className="font-bold mt-2">Total Score: {json.total_score}</p>
        </div>

        {/* Difficulty */}
        <div className="mt-6">
          <h3 className="font-bold text-lg mb-2">
            If you circled any problems, how difficult have these made it for you?
          </h3>
          {["Not difficult at all", "Somewhat difficult", "Very difficult", "Extremely difficult"].map((opt) => (
            <span
              key={opt}
              className={`px-3 py-1 rounded-full text-sm font-sans mr-2 mb-2 inline-block ${
                json.qanswer_4_10 === opt
                  ? "bg-blue-600 text-white border border-blue-600"
                  : "bg-white border-2 border-gray-300 text-black"
              }`}
            >
              {opt}
            </span>
          ))}
        </div>

        {/* Footer */}
       {/* Healthcare Professionals Note */}
<div className="mt-6 p-4 bg-gray-100 border-l-4 border-blue-600 rounded-md text-gray-800">
  <p className="font-semibold mb-2">For healthcare professionals:</p>
  <p>
    Because this questionnaire relies on patient self-report, all responses should be verified by the clinician.
    A definitive diagnosis should be made on clinical grounds, taking into account how well the patient understood
    the questionnaire, as well as other relevant information from the patient. Be sure to exclude the effects of a
    substance.
  </p>
</div>

      </div>
    </div>
  );
};

export default ViewPhq9;
